import { METRIC_NAMES } from '@config/Consts';

/**
 * Model consumed by SkillsListService & its transformers
 */
class ManagerMetricsModel {
  constructor(options) {
    this.id = options.id;
    this[METRIC_NAMES.SKILL_ASSIGNED_CONVERSATIONS] =
      options[METRIC_NAMES.SKILL_ASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.SKILL_LOAD] =
      options[METRIC_NAMES.SKILL_LOAD];
    this[METRIC_NAMES.SKILL_ONLINE_AGENTS] =
      options[METRIC_NAMES.SKILL_ONLINE_AGENTS];
    this[METRIC_NAMES.SKILL_AWAY_AGENTS] =
      options[METRIC_NAMES.SKILL_AWAY_AGENTS];
    this[METRIC_NAMES.SKILL_BACK_SOON_AGENTS] =
      options[METRIC_NAMES.SKILL_BACK_SOON_AGENTS];
    this[METRIC_NAMES.SKILL_CLOSED_CONVERSATIONS] =
      options[METRIC_NAMES.SKILL_CLOSED_CONVERSATIONS];
    this[METRIC_NAMES.AVG_WAIT_TIME] =
      options[METRIC_NAMES.AVG_WAIT_TIME];
    this[METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE] =
      options[METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE];
    this[METRIC_NAMES.AVG_TIME_TO_RESPONSE] =
      options[METRIC_NAMES.AVG_TIME_TO_RESPONSE];
    this[METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT] =
      options[METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT];
    this[METRIC_NAMES.SKILLS_SKILL_NAME] =
      options[METRIC_NAMES.SKILLS_SKILL_NAME];
    // moved from reporting API
    this[METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS] =
      options[METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.OVERDUE_IN_QUEUE] =
      options[METRIC_NAMES.OVERDUE_IN_QUEUE];
    this[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE] =
      options[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE];
    this[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE] =
      options[METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE];
  }
}

export default ManagerMetricsModel;
